var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletFooter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.996 5.375v-.037C19.996 1.978 17.96 0 14.514 0h-9.03C2.036 0 0 1.979 0 5.338v7.316C0 16.014 2.036 18 5.484 18h9.033C17.964 18 20 16.014 20 12.654v-.306h-4.238c-1.975-.002-3.574-1.566-3.57-3.491.003-1.922 1.6-3.478 3.57-3.482h4.234z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.744 5.367H10.395a.756.756 0 0 0 .762-.75.757.757 0 0 0-.77-.742H4.745a.756.756 0 0 0-.762.743.756.756 0 0 0 .762.75zm9.297 3.93c.21.95 1.043 1.62 1.996 1.603h3.25a.726.726 0 0 0 .717-.734V7.634a.728.728 0 0 0-.718-.734H15.96c-1.083.003-1.958.902-1.956 2.01 0 .13.013.26.037.387zm2.96-.397a1 1 0 1 1-2 0 1 1 0 0 1 2 0z",
    fill: "#1080FF",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletFooter);
export default __webpack_public_path__ + "static/media/walletFooter.8e3f4bada8b27b678d8fa40625072445.svg";
export { ForwardRef as ReactComponent };